import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './HelpCenterTabs.css';

const HELP_CENTER_ROUTES = [
  {
    key: 'faq',
    label: 'Preguntas frecuentes',
    href: '/ayuda/preguntas-frecuentes',
    matches: location => location.pathname === '/ayuda/preguntas-frecuentes',
  },
  {
    key: 'new-ticket',
    label: 'Crear ticket',
    href: '/dashboard?section=support-new',
    matches: location => {
      if (location.pathname !== '/dashboard') {
        return false;
      }
      const params = new URLSearchParams(location.search);
      return params.get('section') === 'support-new';
    },
  },
  {
    key: 'tickets',
    label: 'Mis tickets',
    href: '/dashboard?section=support-tickets',
    matches: location => {
      if (location.pathname !== '/dashboard') {
        return false;
      }
      const params = new URLSearchParams(location.search);
      return params.get('section') === 'support-tickets';
    },
  },
  {
    key: 'tutorials',
    label: 'Tutoriales',
    href: '/tutoriales',
    matches: location => location.pathname === '/tutoriales',
  },
];

const HelpCenterTabs = () => {
  const location = useLocation();

  const tabs = useMemo(
    () =>
      HELP_CENTER_ROUTES.map(tab => ({
        ...tab,
        isActive: tab.matches(location),
      })),
    [location]
  );

  return (
    <nav className="help-center-tabs" aria-label="Secciones del centro de ayuda">
      <div className="help-center-tabs__container">
        {tabs.map(tab => (
          <Link
            key={tab.key}
            to={tab.href}
            className={`help-center-tabs__item${tab.isActive ? ' is-active' : ''}`}
            aria-current={tab.isActive ? 'page' : undefined}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default HelpCenterTabs;
